import { render, staticRenderFns } from "./VendorManagementDataView.vue?vue&type=template&id=4ebdf893&scoped=true"
import script from "./VendorManagementDataView.vue?vue&type=script&lang=js"
export * from "./VendorManagementDataView.vue?vue&type=script&lang=js"
import style0 from "./VendorManagementDataView.vue?vue&type=style&index=0&id=4ebdf893&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebdf893",
  null
  
)

export default component.exports